<template>
  <div :class="{ 'bg-slate-middle': props.active }">
    <div
      class="absolute h-5 w-5 cursor-pointer top-2 right-2 z-10 flex items-center justify-center"
      tabindex="0"
      @pointerup.stop="emit('toggleWallMenu')"
      @keydown.enter.stop="emit('toggleWallMenu')"
    >
      <p v-if="!props.active" class="relative text-3xl text-white text-center -mt-3">...</p>
      <img v-else class="w-5 p-px invert rotate-45" :src="Plus" :alt="t('aria-close')" />
    </div>
    <div v-if="user && props.active" class="flex flex-col items-start">
      <p
        v-if="
          !common.actions.hasMinimumPermission(user, PermissionLevel.Organize, wall) &&
          !common.actions.hasMinimumPermission(user, PermissionLevel.Owner, wall) &&
          !common.actions.hasMinimumPermission(user, PermissionLevel.Copy, wall) &&
          wall.details.pin.length === 0
        "
        class="text-white text-left text-lg py-1"
      >
        {{ t('nothingtodisplay') }}
      </p>
      <button
        v-if="common.actions.hasMinimumPermission(user, PermissionLevel.Organize, wall)"
        class="text-white text-left text-lg py-1 px-2"
        @pointerup.stop="emit('invokeEditPopup')"
        @keydown.enter.stop="emit('invokeEditPopup')"
      >
        {{ t('edit') }}...
      </button>
      <button
        v-if="common.actions.hasMinimumPermission(user, PermissionLevel.Copy, wall)"
        class="text-white text-left text-lg py-1 px-2"
        @pointerup.stop="emit('duplicate')"
        @keydown.enter.stop="emit('duplicate')"
      >
        {{ t('duplicate') }}
      </button>
      <button
        v-if="common.actions.hasMinimumPermission(user, PermissionLevel.Organize, wall)"
        class="text-white text-left text-lg py-1 px-2"
        @pointerup.stop="emit('exportFile')"
        @keydown.enter.stop="emit('exportFile')"
      >
        {{ t('export') }}
      </button>
      <button
        v-if="wall.details.permaLink && common.actions.hasMinimumPermission(user, PermissionLevel.Join, wall)"
        class="text-white text-left text-lg py-1 px-2"
        @pointerup.stop="emit('copyWallLink')"
        @keydown.enter.stop="emit('copyWallLink')"
      >
        {{ t('copywalllink') }}
      </button>

      <button
        v-if="common.actions.hasMinimumPermission(user, PermissionLevel.Join, wall) && wall.details.pin.length > 0"
        class="text-white text-left text-lg py-1 px-2"
        @pointerup.stop="emit('copyWallPin')"
        @keydown.enter.stop="emit('copyWallPin')"
      >
        {{ t('copywallpin') }}: {{ wall.details.pin }}
      </button>
      <button
        v-if="common.actions.hasMinimumPermission(user, PermissionLevel.Owner, wall)"
        class="text-white text-left text-lg py-1 px-2"
        @pointerup.stop="emit('invokeDeletionPopup')"
        @keydown.enter.stop="emit('invokeDeletionPopup')"
      >
        {{ t('delete') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { PermissionLevel } from '@/constants'
  import useCommonStore from '@/composables/common'
  import { useUserStore } from '@/composables/userStore'
  import { Wall } from '@/common/classes'
  import { PropType } from 'vue'
  import { useI18n } from 'vue-i18n'
  import Plus from '@/assets/icons/fontawesome/plus-solid.svg'

  const common = useCommonStore()
  const userStore = useUserStore()
  const user = userStore.getters.user

  const messages = {
    no: {
      newwall: 'Ny tavle',
      time: 'laget',
      updated: 'oppdatert',
      created: 'Laget',
      edited: 'Redigert',
      nowalls: 'Du har ikke laget eller deltatt på en tavle enda.',
      accessdenied: 'Du har ikke adgang til denne tavlen, spør eieren om adgang',
      share: 'Del',
      copywallpin: 'Kopier PIN til tavle',
      copywalllink: 'Kopier lenke til tavla',
      includingsubject: ': emne',
      sharedby: 'Delt av',
      in: 'i',
    },
    en: {
      newwall: 'New wall',
      time: 'time',
      updated: 'update',
      created: 'Created',
      edited: 'Edited',
      nowalls: 'You have not joined or created a wall yet.',
      accessdenied: "You don't have access to this wall, ask the owner to allow access",
      share: 'Share',
      copywallpin: 'Copy wall PIN',
      copywalllink: 'Copy wall link',
      includingsubject: ': subject',
      sharedby: 'Shared by',
      in: 'in',
    },
  }

  const { t } = useI18n({ messages })

  const props = defineProps({
    active: { type: Boolean, default: false },
    wall: { type: Object as PropType<Wall>, required: true },
  })

  const emit = defineEmits<{
    (e: 'toggleWallMenu'): void
    (e: 'invokeEditPopup'): void
    (e: 'duplicate'): void
    (e: 'exportFile'): void
    (e: 'copyWallPin'): void
    (e: 'copyWallLink'): void
    (e: 'invokeDeletionPopup'): void
  }>()
</script>
